import { PERMISSION_CODES } from '../../../constants/permissions';
import {
  PRIVACY_POLICY_PAGE_URL,
  TERMS_OF_SERVICE_PAGE_URL,
} from '../../../constants/appConfig';
import { hasAuthPermissionCheck } from '../../../utility/permissions';
import { isPremiumUserCheck } from '../../../utility/subscriptionHelper';

export const getUserMenuItems = (
  labels,
  pathname,
  accessControl,
  organizationData,
  has2FA,
  is2FARequired,
  onRedirect,
  onLogOut,
  onManageSubscription,
  onInstructionGuideDrawerClick,
  onClearDemoData,
  onAuthentication
) => {
  const isPremiumUser = isPremiumUserCheck(organizationData);
  const hasDemoData = organizationData?.has_demo_data;
  const canManageSlackIntegration = hasAuthPermissionCheck(
    PERMISSION_CODES.SETTINGS_SLACK_INTEGRATION_MANAGE,
    accessControl
  );
  const canManageDemoData = hasAuthPermissionCheck(
    PERMISSION_CODES.SETTINGS_DEMO_DATA_MANAGE,
    accessControl
  );
  const canManageSubscription = hasAuthPermissionCheck(
    PERMISSION_CODES.SETTINGS_SUBSCRIPTION_MANAGE,
    accessControl
  );
  const canManageFeatures = hasAuthPermissionCheck(
    PERMISSION_CODES.SETTINGS_FEATURES_MANAGE,
    accessControl
  );
  const canManagePermissions = hasAuthPermissionCheck(
    PERMISSION_CODES.SETTINGS_PERMISSIONS_MANAGE,
    accessControl
  );
  const canManageDocuments = hasAuthPermissionCheck(
    PERMISSION_CODES.SETTINGS_DOCUMENTS_MANAGE,
    accessControl
  );
  const canManagePersonInfoFields = hasAuthPermissionCheck(
    PERMISSION_CODES.SETTINGS_PERSON_FIELDS_INFO_MANAGE,
    accessControl
  );

  return [
    ...(canManageSubscription && isPremiumUser
      ? [
          {
            id: 1,
            name: labels.manageSubscription,
            action: onManageSubscription,
            isExternal: false,
          },
        ]
      : []),
    ...(canManageFeatures ||
    canManagePermissions ||
    canManageDocuments ||
    canManagePersonInfoFields
      ? [
          {
            id: 2,
            name: labels.organizationSettings,
            action: onRedirect('/organization-settings'),
            isDisabled: pathname.includes('organization-settings'),
            isExternal: false,
          },
        ]
      : []),
    ...(canManageSlackIntegration && isPremiumUser
      ? [
          {
            id: 3,
            name: labels.slackIntegration,
            action: onRedirect('/slack-integration'),
            isDisabled: pathname.includes('slack-integration'),
            isExternal: false,
          },
        ]
      : []),
    ...(canManageDemoData && hasDemoData
      ? [
          {
            id: 4,
            name: labels.clearDemoData,
            action: onClearDemoData,
            isExternal: false,
          },
        ]
      : []),
    {
      id: 5,
      name: labels.releaseNotes,
      action: onRedirect('/release-notes'),
      isDisabled: pathname.includes('release-notes'),
      isExternal: false,
    },
    {
      id: 6,
      name: labels.privacyPolicy,
      action: PRIVACY_POLICY_PAGE_URL,
      isExternal: true,
    },
    {
      id: 7,
      name: labels.termsOfService,
      action: TERMS_OF_SERVICE_PAGE_URL,
      isExternal: true,
    },
    {
      id: 8,
      name: labels.helpCenter,
      action: () => onInstructionGuideDrawerClick(true),
    },
    ...(!has2FA && !is2FARequired
      ? [
          {
            id: 9,
            name: labels.enableAuthentication,
            action: onAuthentication,
          },
        ]
      : []),
    ...(has2FA
      ? [
          {
            id: 10,
            name: is2FARequired
              ? labels.resetAuthentication
              : labels.disableAuthentication,
            action: onAuthentication,
          },
        ]
      : []),
    {
      id: 11,
      name: labels.logOut,
      action: onLogOut,
    },
  ];
};
